import { StyleSheet } from "@react-pdf/renderer";

export const productsDataStyles=()=>{
    const productsData = StyleSheet.create({
        titleRow: {
            flexDirection: 'row',
            borderWidth:1,
            backgroundColor: 'rgb(229, 229, 229)',
            width: '100%',
            justifyContent: 'center',
            marginTop:2
        },

        row: {
            flexDirection: 'row',
            justifyContent: 'center',
            borderBottomWidth: 1,
        },

    });

    return {
        productsData
    }
}